import { BOOKING_FLOW_TYPE } from 'Constants/constants';

export const getSelectPageURL = (id: any) => {
	return `/book/${id}/select`;
};

export const isReservationFlow = (product: any) =>
	!!product?.flowType && product.flowType === BOOKING_FLOW_TYPE.RESERVATION;
